<template>
    <div style="background: #F6F6F6;">
        <van-pull-refresh v-model="isProductLoading" @refresh="onRefresh"
                          pulling-text="Se puede actualizar desplegando..."
                          loosing-text="Se puede actualizar liberando..."
                          loading-text="En carga..."
        >
        <div class="audithome_wrap" id="firstloan_head">
            <div class="audithome_head">
                <div class="audithome_hleft">Superapoyomax</div>
                <div class="audithome_hright">
                    <div class="audithome_hrimg">
                        <!--<img src="../../assets/img/audithome_icon01.png" />-->
                    </div>
                    <div class="audithome_hrimg" @click.stop="onHomeMenus">
                        <!--<img src="../../assets/img/audithome_icon02.png" />-->
                    </div>
                </div>
            </div>
        </div>

        <div id="firstloan">
            <div class="audithome_cont" :class="calculationInfo ? 'audithome_cont_height' : '' ">
                <div class="audithome_cview">
                    <div class="auditpass_wrap">
                        <div class="mobhome_onewrap">
                            <div class="mobhome_twoview">
                                <div class="mobhome_tview">
                                    <div class="kychome_slider_title">El monto solicitado de su préstamo</div>
                                    <div class="eshoy_slider_cont mobhome_tview_slider">
                                        <div class="loan-content-box">
                                            <div class="moneybox">
                                                $ <span id="money">{{ dealNumber(sliderValue) }}</span>
                                            </div>

                                            <div class="sliderbox_wrap">
                                                <div class="sliderbox_left">
                                                    <div class="sliderbox_cimg">
                                                        <img class="eshoy_gold_small" src="../../assets/img/eshoy_gold_small.png" alt="">
                                                    </div>
                                                    <div class="sliderbox_ctext" v-if="products">
                                                        $<span>{{ products.mir_env_pfp }}</span>
                                                    </div>
                                                </div>
                                                <div class="sliderbox_middle">
                                                    <div class="sliderBox" v-if="products">

                                                        <van-slider
                                                                v-model="sliderValue"
                                                                :min="products.mir_env_pfp"
                                                                :max="products.aft_hws_cuj"
                                                                :step="50"
                                                                bar-height="6px"
                                                                inactive-color="D8D8D8"
                                                                @change="onSliderChange"
                                                        >
                                                        </van-slider>

                                                    </div>
                                                </div>
                                                <div class="sliderbox_right">
                                                    <div class="sliderbox_cimg">
                                                        <img class="eshoy_gold_more" src="../../assets/img/eshoy_gold_more.png" alt="">
                                                    </div>
                                                    <div class="sliderbox_ctext">
                                                        <div class="sliderbox_ctext_view" v-if="products">
                                                            $<span>{{ products.aft_hws_cuj }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="confirmloan_cmview confirmloan_cmview_repeat" >
                                            <div class="itoken_check_vitems" @click="onShowLoanDays">
                                                <div class="itoken_check_vitem">
                                                    <div class="itoken_check_vitop">
                                                        <div class="itoken_check_vitleft_coupon">
                                                            <span style="font-size: 0.388889rem">Días de plazo préstamo</span>
                                                        </div>
                                                        <div class="itoken_check_vitright">
                                                            <div class="itoken_check_vitrnums" style="font-weight: 400">{{ radioDays }} días</div>
                                                            <div class="itoken_check_vitrarrow">
                                                                <template v-if="showLoanDetail">
                                                                    <img src="../../assets/img/trialOneCclose_arrowup.webp" alt="" />
                                                                </template>
                                                                <template v-else>
                                                                    <img src="../../assets/img/trialOneCclose_arrowdown.webp" alt="" />
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="eshoy_slider_btns">
                                            <div class="eshoy_slider_btn_view" @click="onHomeConfirm">
                                                <van-button color="linear-gradient(to top, #0F9F52, #2DDD7F)" block style="height: 1.111111rem; border-radius: 8px;">
                                                    <span style="font-weight: 500;">Solicitar ahora su prestamo</span>
                                                </van-button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div class="mobhome_twoview" style="margin-top: 10px;" v-if="calculationInfo">
                                <template v-if="calculationInfo">
                                    <div class="firstloan_loantitle">Detalles del préstamo</div>
                                    <div class="confirmloan_cmview">
                                        <div class="confirmloan_cmitems itoken_checkvi_scale-1px">
                                            <div class="confirmloan_cmileft">Monto de Préstamo</div>
                                            <div class="confirmloan_cmiright">${{ calculationInfo.myi_hop_pek }}</div>
                                        </div>

                                        <div class="confirmloan_cmitems itoken_checkvi_scale-1px">
                                            <div class="confirmloan_cmileft">Plazo</div>
                                            <div class="confirmloan_cmiright"
                                            >{{ calculationInfo.sas_dsz_vuf }} Días</div
                                            >
                                        </div>

                                        <div class="confirmloan_cmitems itoken_checkvi_scale-1px">
                                            <div class="confirmloan_cmileft">Fecha de Pago</div>
                                            <div class="confirmloan_cmiright">{{ calculationInfo.luc_nhd_dmo }}</div>
                                        </div>

                                        <div class="itoken_check_vitems" @click="onShowLoanDetail" :class="showLoanDetail ? '' : 'itoken_checkvi_scale-1px'">
                                            <div class="itoken_check_vitem">
                                                <div class="itoken_check_vitop">
                                                    <div class="itoken_check_vitleft_coupon">
                                                        <span style="font-size: 0.388889rem">Monto a Pagar</span>
                                                    </div>
                                                    <div class="itoken_check_vitright">
                                                        <div class="itoken_check_vitrnums" style="font-weight: 400"></div>
                                                        <div class="itoken_check_vitrarrow">
                                                            <template v-if="showLoanDetail">
                                                                <img src="../../assets/img/trialOneCclose_arrowup.webp" alt="" />
                                                            </template>
                                                            <template v-else>
                                                                <img src="../../assets/img/trialOneCclose_arrowdown.webp" alt="" />
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="itoken_check_vitems_details" v-if="showLoanDetail">
                                            <div class="itoken_check_vitems_detail">
                                                <div class="confirmloan_msgitems">
                                                    <div class="confirmloan_msgileft">Principal</div>
                                                    <div class="confirmloan_msgiright"
                                                    >$<span>{{ calculationInfo.mhv_cjz_hgv }}</span></div
                                                    >
                                                </div>

                                                <div class="confirmloan_msgitems">
                                                    <div class="confirmloan_msgileft">Interés</div>
                                                    <div class="confirmloan_msgiright"
                                                    >$<span>{{ calculationInfo.kmi_eve_gzt }}</span></div
                                                    >
                                                </div>

                                                <div class="confirmloan_msgitems">
                                                    <div class="confirmloan_msgileft">IVA</div>
                                                    <div class="confirmloan_msgiright"
                                                    >$<span>{{ calculationInfo.hkf_frh_klx }}</span></div
                                                    >
                                                </div>

                                                <div class="confirmloan_msgitems">
                                                    <div class="confirmloan_msgileft">Cobro de Servicio</div>
                                                    <div class="confirmloan_msgiright"
                                                    >$<span>{{ calculationInfo.qij_wyk_ywo }}</span></div
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <img @click.stop="onGotoLoan" alt="" src="@/assets/loopimg/loopindex_vdimg.webp" />
                                </template>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="auditcommon_cont">
            <!--<div class="auditcommon_one">
                <div class="auditcommon_oitem">
                    <img src="../../assets/img/homefooter_icon01.png" />
                </div>
                <div class="auditcommon_oitem">
                    <img src="../../assets/img/homefooter_icon02.png" />
                </div>
                <div class="auditcommon_oitem">
                    <img src="../../assets/img/homefooter_icon03.png" />
                </div>
                <div class="auditcommon_oitem">
                    <img src="../../assets/img/homefooter_icon06.png" />
                </div>
            </div>-->
            <div class="auditcommon_two"></div>
            <div class="auditcommon_thr" style="margin-bottom: 50px;">
                <img src="../../assets/img/homefooter_icon05.jpg" />
            </div>
        </div>

        <!--<template v-show="loanDaysShow">
            <van-action-sheet
                    v-model="loanDaysShow"
                    :actions="actionsLoanDays"
                    cancel-text="Cancelar"
                    description="Días de plazo préstamo"
                    close-on-click-action
                    @select="onSelectLoanDays"
            />
        </template>-->


        <van-popup v-model="loanDaysShow" position="bottom" round>
            <div class="verifycode_wrap">
                <div class="verifycode_cont">
                    <div class="verifycode_tilte"></div>
                    <div class="verifycode_top verifycode_coupons_top">
                        <div class="verifycode_tleft">
                            <span>
                                Plan de reembolso
                            </span>
                        </div>
                        <div class="verifycode_tright" @click="loanDaysShow = false">
                            <img src="@/assets/mobimg/verifycode_tright.png" alt="">
                        </div>
                    </div>

                    <div class="coupons_form">
                        <div class="coupons_list">
                            <van-radio-group v-model="radioDays" @change="onRadioChange">
                                <van-cell-group>
                                    <template v-for="(item, index) in daysList">
                                        <div class="coupons_items" :key="item.uyo_mbc_sie" :class="index == daysList.length - 1 ? 'coupons_items_end' :''">
                                            <div class="coupons_item" :class="item.uyo_mbc_sie == radioDays ? 'coupons_active' : ''">
                                                <van-cell clickable @click="onProduct(item)">
                                                    <template #title>
                                                        <div class="coupons_ileft">
                                                            <div class="coupons_ilname">{{item.uyo_mbc_sie}} días</div>
                                                            <div class="coupons_ildesc">Fecha de reembolso：{{item.paytime}}</div>
                                                        </div>
                                                    </template>

                                                    <template #right-icon>
                                                        <div class="coupons_iright">
                                                            <div class="coupons_irview">
                                                                <van-radio :name="item.uyo_mbc_sie" >
                                                                    <template #icon="props">
                                                                        <img v-if="props.checked" src="@/assets/mobimg/radio_ischeck.png" alt="">
                                                                        <img v-else src="@/assets/mobimg/radio_nocheck.png" alt="">
                                                                    </template>
                                                                </van-radio>
                                                            </div>
                                                        </div>
                                                    </template>

                                                </van-cell>
                                            </div>
                                        </div>
                                    </template>
                                </van-cell-group>
                            </van-radio-group>
                        </div>
                    </div>

                    <div class="verifycode_footer_btns">
                        <div class="verifycode_footer_btn">
                            <van-button round color="#00CA88" block @click="onDaysConfirm">
                                <span style="font-weight: bold; font-size: 16px;">Enterado</span>
                            </van-button>
                        </div>
                    </div>

                </div>
            </div>
        </van-popup>

        <van-tabbar v-model="tabactive" active-color="#19A95C" inactive-color="#999999" @change="onTabChange">
            <van-tabbar-item icon="wap-home">Inicio</van-tabbar-item>
            <van-tabbar-item icon="contact">Yo</van-tabbar-item>
        </van-tabbar>
        </van-pull-refresh>
    </div>
</template>

<script type="text/javascript">

    import { getTimezoneName, getUserIp } from '@/utils/commonParams';
    import { loadingShow, loadingHide } from '@/utils/loading'
    import { parseTime, getNextDate, getQueryString } from "@/utils/index"
    import { getAccessToken } from '@/utils/auth';

    import { getAccountInfo } from '@/api/apply';
    import { getProductinfo, createOrder, calculationTrial, confirmOrder } from '@/api/loan'

    import { Toast } from 'vant';
    import $ from 'jquery';
    let apiHead = '';

    export default{
        data() {
            return {
                tabactive: 0,
                menusShow: false,
                changeNum: 50,
                sliderValue: 200,
                showLoanDetail: false,
                loanDays: 7,
                loanDaysShow: false,
                actionsLoanDays: [
                    { id: '7', name: '7'},
                    { id: '9', name: '9'},
                    { id: '14', name: '14'},
                    { id: '29', name: '29'},
                    { id: '60', name: '60'},
                ],
                daysList: [],
                daysCheck: null,
                radioDays: null,
                products: null,
                isProductLoading: false,
                calculationInfo: null,
                silderChangeVal: 0,
            }

        },
        mounted() {
            this.countDown();
            this.getProductListApi();
        },
        methods: {
            onSliderChange(value){
                console.log(value)
                this.calculationInfo = null;
                this.silderChangeVal = value;
                //let products = this.products;
                //this.onCreateOrder(products, value);
            },
            onTabChange(item) {
                if(item == 0){
                    this.$router.replace({
                        path: '/loanpage/reapeatloan'
                    })
                } else if(item == 1){
                    this.$router.push({
                        path: '/loanpage/usercenter'
                    })
                }
            },
            onSelectLoanDays(data) {
                this.loanDays = data.id;
            },
            onShowLoanDays() {
                this.loanDaysShow = true;
            },
            onShowLoanDetail() {
                this.showLoanDetail = !this.showLoanDetail;
            },
            onHomeConfirm() {
                /*let calculationInfo = this.calculationInfo;
                if(calculationInfo){
                    this.onCheckTokenKey();
                } else {
                    Toast('请先试算');
                    Toast('Por favor, haga clic en el cálculo de prueba primero.')
                }*/
                let products = this.products;
                let sliderValue = this.sliderValue;
                this.onCreateOrder(products, sliderValue);
            },
            onCloseMeuns() {
                this.menusShow = false;
            },
            onHomeMenus() {
                this.menusShow = true;
            },
            countDown() { // 传入时间戳
                const d = new Date('2025-07-6').getTime()
                if(d && d != 0){
                    const now = new Date().getTime();
                    let timeStamp = d - now;

                    console.log(timeStamp)
                    this.time = timeStamp;
                }
            },
            dealNumber(num) {
                if (num != 0 && num) {
                    num = num + "";
                    let splitList = num.split(".");
                    //将整数部分拆解为单个数字的数组倒序，然后拼装为新的数组，每3位数字进行一次匹配
                    let intStrList = splitList[0]
                        .split("")
                        .reverse()
                        .join("")
                        .match(/(\d{1,3})/g);
                    //将匹配后的数组用，拼接，再拆解为单个数字的数组，反转为原先数组形式，拼接为完整数字
                    let intStr = intStrList.join(",").split("").reverse().join("");
                    return intStr;
                }
                return num;
            },
            onRefresh() {
                this.isProductLoading = true;
                this.getProductListApi();
            },
            onCheckTokenKey() {
                let tokenKey = this.$store.state.common.tokenKey;

                if(tokenKey && tokenKey.length > 0){
                    this.onConfirmOrder(tokenKey);
                } else {
                    let _this = this;
                    setTimeout(() => {
                        client.record("login").then((r) => {
                            console.log(r);
                            //localStorage.setItem("tokenKey", r);
                            _this.$store.commit('common/SET_TOKEN_KEY', r);

                            _this.onConfirmOrder(r);
                        });
                    }, 10);
                }
            },
            async onConfirmOrder(tokenKey) {
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let productInfo = this.products;

                    console.log('产品信息');
                    console.log(productInfo)

                    let postData = {};
                    let silderChangeVal  = this.silderChangeVal;
                    if(silderChangeVal && silderChangeVal > 0){
                        postData = {
                            zzm_yya_hqb: getAccessToken(),
                            aaa_off_csl: '111',
                            vjk_fjt_bvh: tokenKey,
                            lck_olj_vmv: String(silderChangeVal),
                            sas_dsz_vuf: String(productInfo.uyo_mbc_sie),
                            oti_fmd_qms: productInfo.id_str,
                            bpb_imu_jqa: '',
                            fkc_cmc_zbn: '',
                            doe_ody_zty: '',
                        };
                    } else {
                        postData = {
                            zzm_yya_hqb: getAccessToken(),
                            aaa_off_csl: '111',
                            vjk_fjt_bvh: tokenKey,
                            lck_olj_vmv: String(productInfo.mir_env_pfp),
                            sas_dsz_vuf: String(productInfo.uyo_mbc_sie),
                            oti_fmd_qms: productInfo.id_str,
                            bpb_imu_jqa: '',
                            fkc_cmc_zbn: '',
                            doe_ody_zty: '',
                        };
                    }

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    loadingShow();
                    confirmOrder(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                if(useDataJSON){
                                    _this.$store.commit('common/SET_PRODUCT_ID', productInfo.id_str);
                                    _this.$router.replace({
                                        path: '/loanpage/loanstatus'
                                    });
                                }
                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                    });
                } else { //未登录
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })
                }
            },
            async getProductListApi() {
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                    };

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    loadingShow();
                    getProductinfo(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        this.isProductLoading = false;
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                this.calculationInfo = null;
                                let useDataJSON = JSON.parse(useData);
                                let product_suitable = [];
                                let { dts_uvj_plp } = useDataJSON;

                                /*let dts_uvj_plp = [
                                    {
                                        "uyo_mbc_sie": 8,
                                        "mir_env_pfp": 200,
                                        "hqi_nqu_zsz": 2013078303100007110,
                                        "nnd_xdd_kbd": 1,
                                        "aft_hws_cuj": 200,
                                        "kad_xdn_wkn": "2013078303100007110",
                                        "gvy_hlf_shs": 8
                                    },
                                    {
                                        "uyo_mbc_sie": 9,
                                        "mir_env_pfp": 500,
                                        "hqi_nqu_zsz": 2013078303100007111,
                                        "nnd_xdd_kbd": 1,
                                        "aft_hws_cuj": 500,
                                        "kad_xdn_wkn": "2013078303100007111",
                                        "gvy_hlf_shs": 9
                                    },
                                    {
                                        "uyo_mbc_sie": 15,
                                        "mir_env_pfp": 900,
                                        "hqi_nqu_zsz": 2013078303100007112,
                                        "nnd_xdd_kbd": 1,
                                        "aft_hws_cuj": 900,
                                        "kad_xdn_wkn": "2013078303100007112",
                                        "gvy_hlf_shs": 15
                                    },
                                ];*/

                                if(dts_uvj_plp && dts_uvj_plp.length > 0){
                                    product_suitable = dts_uvj_plp;
                                    for(let i=0; i<product_suitable.length; i++){
                                        let nowTime = new Date().getTime();

                                        let nowDate = parseTime(nowTime, '{y}-{m}-{d}'); //获取当前时间
                                        let useDate = getNextDate(nowDate, product_suitable[i].uyo_mbc_sie, "{d}/{m}/{y}");

                                        product_suitable[i].paytime = useDate;
                                        console.log(useDate)
                                    }

                                    product_suitable.sort((a,b) => {return b.uyo_mbc_sie - a.uyo_mbc_sie});

                                    console.log(product_suitable)

                                    product_suitable[0].normal_amount = Number(product_suitable[0].aft_hws_cuj);

                                    _this.products = product_suitable[0];
                                    _this.daysCheck = product_suitable[0];
                                    _this.radioDays = product_suitable[0].uyo_mbc_sie;
                                    //_this.onCreateOrder(product_suitable[0]);
                                }

                                console.log(product_suitable)

                                _this.daysList = product_suitable;

                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                        this.isProductLoading = false;
                    });
                } else { //未登录
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })
                }
            },
            onRadioChange(e){
                console.log(e)
            },
            onDaysConfirm() {
                this.products = null;
                let usedaysCheck = this.daysCheck;
                console.log(usedaysCheck)
                this.radioDays = usedaysCheck.uyo_mbc_sie;
                this.products = usedaysCheck;
                this.loanDaysShow = false;
            },
            onProduct(data){ //选择产品
                this.daysCheck = data;
                this.radioDays = data.uyo_mbc_sie;
            },
            onGotoLoan() {
                let products = this.products;

                this.onCreateOrder(products);
            },
            async onCreateOrder(productInfo, amount) {

                console.log(productInfo)
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)
                    let postData = {};
                    if(amount && amount > 0){
                        postData = {
                            zzm_yya_hqb: getAccessToken(),
                            aaa_off_csl: '111',
                            llg_pys_mii: '1',
                            lck_olj_vmv: String(amount),
                            sas_dsz_vuf: String(productInfo.uyo_mbc_sie),
                            oti_fmd_qms: productInfo.id_str,
                            // lck_olj_vmv: '200',
                            // sas_dsz_vuf: '7',
                            // oti_fmd_qms: '2013078303100007002',
                        }
                    } else {
                        postData = {
                            zzm_yya_hqb: getAccessToken(),
                            aaa_off_csl: '111',
                            llg_pys_mii: '1',
                            lck_olj_vmv: String(productInfo.mir_env_pfp),
                            sas_dsz_vuf: String(productInfo.uyo_mbc_sie),
                            oti_fmd_qms: productInfo.id_str,
                        };
                    }

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    loadingShow();
                    createOrder(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        //loadingHide()
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                if(useDataJSON){
                                    _this.$store.commit('common/SET_PRODUCT_INFO', null);
                                    let { bqr_rle_jto } = useDataJSON;
                                    if([7101, 7102, 7105, 8110].indexOf(bqr_rle_jto) >= 0){
                                        //_this.getCalculationTrial(productInfo);
                                        loadingHide()
                                        _this.$store.commit('common/SET_PRODUCT_ID', productInfo.id_str);

                                        console.log(productInfo)

                                        let productInfoStr = JSON.stringify(productInfo)

                                        console.log(productInfoStr)

                                        _this.$store.commit('common/SET_PRODUCT_INFO', productInfoStr);

                                        let useamount = 0;
                                        if(amount && amount > 0){
                                            useamount = amount;
                                        } else {
                                            useamount = productInfo.mir_env_pfp;
                                        }
                                        this.$router.push({
                                            path: '/loanpage/confirmloan',
                                            query: {
                                                amount: useamount,
                                            }
                                        })
                                    } else if(this.isCompleteInfo(bqr_rle_jto)){
                                        if(bqr_rle_jto == 8001){
                                            loadingHide()
                                            this.$router.push({
                                                path: '/loanpage/applywork'
                                            })
                                        } else if(bqr_rle_jto == 8002){
                                            loadingHide()
                                            this.$router.push({
                                                path: '/loanpage/applycontacts'
                                            })
                                        } else if(bqr_rle_jto == 8004){
                                            loadingHide()
                                            this.$router.push({
                                                path: '/loanpage/applyperson'
                                            })
                                        } else if(bqr_rle_jto == 8005){
                                            loadingHide()
                                            this.$router.push({
                                                path: '/loanpage/applyidcard'
                                            })
                                        } else if(bqr_rle_jto == 8010){
                                            loadingHide()
                                            this.$router.push({
                                                path: '/loanpage/applybank'
                                            })
                                        }
                                    } else if([7106, 8006].indexOf(bqr_rle_jto) >= 0){
                                        loadingHide()
                                        this.$router.push({
                                            path: '/loanpage/livingverify',
                                            query: {
                                                isreloan: 1,
                                            }
                                        })
                                    }

                                    //this.calculationInfo = useDataJSON;

                                    // 本金 loan lck_olj_vmv
                                    // 利息 interest_fee kmi_eve_gzt
                                    // 税费 vat hkf_frh_klx
                                    // 服务费 fee qij_wyk_ywo

                                }
                            } else {
                                loadingHide()
                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                    });
                } else { //未登录
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })
                }
            },
            isCompleteInfo: val => {
                return [8001, 8002, 8004, 8005, 8010].indexOf(val) >= 0;
            },
            async getCalculationTrial(productInfo){
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                        llg_pys_mii: '1',
                        lck_olj_vmv: String(productInfo.mir_env_pfp),
                        sas_dsz_vuf: String(productInfo.uyo_mbc_sie),
                        oti_fmd_qms: productInfo.id_str,
                        // lck_olj_vmv: '200',
                        // sas_dsz_vuf: '7',
                        // oti_fmd_qms: '2013078303100007002',
                    };

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    loadingShow();
                    calculationTrial(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                if(useDataJSON){
                                    this.calculationInfo = useDataJSON;

                                    // 本金 loan lck_olj_vmv
                                    // 利息 interest_fee kmi_eve_gzt
                                    // 税费 vat hkf_frh_klx
                                    // 服务费 fee qij_wyk_ywo

                                }
                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                    });
                } else { //未登录
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })
                }
            }
        }
    }

</script>

<style scss scoped>
    .audithome_wrap{
        width: 100%;
        height: 9.861111rem;
        background: linear-gradient(180deg, #19A95C 0%, #F6F6F6 100%);
    }
    .audithome_head{
        width: 100%;
        height: 1.333333rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0 0.444444rem;
    }
    .audithome_hleft{
        width: 5.555556rem;
        height: 0.583333rem;
        font-size: 0.5rem;
        font-weight: 500;
        color: #FFFFFF;
    }
    .audithome_hright{
        width: 1.361111rem;
        height: 0.5rem;
        display: flex;
        justify-content: space-between;
    }
    .audithome_hrimg{
        width: 0.5rem;
        height: 0.5rem;
    }
    .audithome_hrimg img{
        display: block;
        width: 0.5rem;
        height: 0.5rem;
    }
    .audithome_tps{
        width: 100%;
        height: 0.833333rem;
        box-sizing: border-box;
        /* background: rgba(255,255,255,0.26);*/
        margin-top: 6px;
    }
    .audithome_tps span{
        width: 100%;
        height: 0.388889rem;
        font-size: 12px;
        font-weight: 400;
        color: #FFFFFF;
        transform: scale(0.9);
        transform-origin:0 0;
        overflow: hidden;
        white-space:nowrap;
        -o-text-overflow:ellipsis;
        text-overflow:ellipsis;
    }
    #firstloan{
        /*padding-bottom: 30px;*/
    }
    #firstloan .audithome_cont{
        width: 100%;
        /*height: 3.7rem;*/
        height: auto;
        position: relative;
    }
    #firstloan .audithome_cview{
        width: 100%;
        height: auto;
        position: absolute;
        left: 0;
        top: -8.6rem;
    }
    #firstloan  .auditpass_wrap{
        width: 100%;
        height: auto;
        position: relative;
    }
    #firstloan .auditpass_bgimg{
        display: block;
        width: 100%;
    }
    #firstloan .audithome_cont .auditpass_view{
        width: 100%;
        height: auto;
        position: absolute;
        left: 0;
        top: 0;
        box-sizing: border-box;
        padding-top: 4.222222rem;
    }
    #firstloan .auditpass_title{
        width: 100%;
        height: 0.972222rem;
        font-size: 0.583333rem;
        font-weight: bold;
        color: #333333;
        line-height: 0.583333rem;
        text-align: center;
    }
    #firstloan .auditpass_desc{
        width: 92.22%;
        height: auto;
        margin: 0 auto;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #666666;
        line-height: 0.472222rem;
        text-align: center;
    }
    #firstloan .auditpass_solid_view{
        width: 100%;
        height: 0.388889rem;
        margin-top: 4.25rem;
        box-sizing: border-box;
        padding: 0 0.444444rem;
        display: flex;
        justify-content: space-between;
    }
    #firstloan .auditpass_solid_middle{
        width: auto;
        height: 0.388889rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #19A95C;
        line-height: 0.388889rem;
    }
    #firstloan .auditpass_solid_left{
        width: 2.916667rem;
        height: 0.388889rem;
        display: flex;
        align-items: center;
    }
    #firstloan .auditpass_solid_left img{
        display: block;
        width: 100%;
        height: 1px;
    }
    #firstloan .auditpass_solid_right{
        width: 2.916667rem;
        height: 0.388889rem;
        display: flex;
        align-items: center;
    }
    #firstloan .auditpass_solid_right img{
        display: block;
        width: 100%;
        height: 1px;
    }
    #firstloan .auditpass_btns{
        width: 92.22%;
        height: 1.222222rem;
        margin: 0 auto;
    }
    .auditcommon_cont{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0 0.416667rem 0.833333rem 0.416667rem;
    }
    .auditcommon_one{
        width: 100%;
        height: 3.638889rem;
    }
    .auditcommon_oitem{
        width: 50%;
        height: 2.083333rem;
        float: left;
    }
    .auditcommon_oitem img{
        display: block;
        width: 100%;
        height: 2.083333rem;
    }
    .auditcommon_two{
        width: 100%;
        height: auto;
        border-radius: 6px;
        margin: 0.416667rem 0;
        overflow: hidden;
    }
    .auditcommon_thr{
        width: 100%;
        height: auto;
    }
    .auditcommon_thr img{
        display: block;
        width: 100%;
    }

    .mobhome_onewrap{
        width: 100%;
        height: auto;
    }
    .mobhome_twoview{
        width: 91.11%;
        height: auto;
        margin: 0 auto;
        background: #ffffff;
        box-sizing: border-box;
        padding: 0.277778rem;
        border-radius: 0.222222rem;
    }
    .mobhome_tview{
        width: 100%;
        height: 100%;
        border-radius: 0.222222rem;

    }
    .mobhome_thrview{
        width: 100%;
        height: 0.916667rem;
        margin: 11px auto 0 auto;
    }
    .mobhome_thrview img{
        width: 43.47%;
        display: block;
        margin: 0 auto;
    }
    .mobhome_fivborder{
        width: 88.89%;
        padding-top: 1.916667rem;
        margin: 0 auto;
    }
    .mobfooter_wrap{
        width: 100%;
        height: auto;
        background: #0A0B0E;
        padding-top: 1.944444rem;
        padding-bottom: 1.944444rem;
    }
    .mobfooter_cont{
        width: 88.89%;
        height: auto;
        margin: 0 auto;
    }
    .mobfooter_title{
        width: 100%;
        height: 0.444444rem;
        font-size: 0.444444rem;
        font-weight: 600;
        color: #E8E8E9;
        line-height: 0.444444rem;
    }
    .mobfooter_list{
        width: 100%;
        height: auto;
        padding-top: 0.333333rem;
    }
    .mobfooter_items{
        width: 100%;
        height: 1.5rem;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
    }
    .mobfooter_ileft{
        width: auto;
        height: 1.5rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #E8E8E9;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .mobfooter_ileft_active{
        color: #39CA80;
    }
    .mobfooter_iright{
        width: 0.277778rem;
        height: 1.5rem;
        display: flex;
        align-items: center;
    }
    .mobfooter_iright img{
        display: block;
        width: 100%;
        height: 0.416667rem;
    }
    .mobfooter_middle{
        width: 100%;
        height: auto;
        padding-top: 1.388889rem;
    }
    .mobfooter_mimg{
        width: 100%;
        padding-top: 0.611111rem;
    }
    .mobfooter_mimg img{
        display: block;
        width: 4.861111rem;
    }
    .mobfooter_down{
        width: 100%;
        padding-top: 1.388889rem;
    }
    .mobfooter_dlist{
        width: 100%;
        height: auto;
        padding-top: 0.333333rem;
    }
    .mobfooter_dlitem{
        width: 100%;
        height: auto;
        padding-top: 0.555556rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #B6B8BF;
    }
    .mobhome_tview .eshoy_slider_cont{
        width: 100%;
        background: none;
    }
    .mobhome_tview .sliderbox_wrap{
        width: 87.5%;
        margin: 0 auto;
    }
    .mobhome_tview .sliderbox_left{
        width: 16.3%;
        height: 1.194444rem;
        padding-top: 1px;
    }
    .mobhome_tview .sliderbox_middle{
        width: 66%;
    }
    .mobhome_tview .sliderbox_right{
        width: 16.3%;
        height: 1.194444rem;
        padding-top: 1px;
    }
    .mobhome_tview .sliderbox_cimg{
        width: 100%;
        height: 0.694444rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .mobhome_tview .eshoy_gold_small{
        display: block;
        width: 24px;
        height: 14px;
    }
    .mobhome_tview .eshoy_gold_more{
        display: block;
        width: 24px;
        height: 21px;
    }
    .mobhome_tview .sliderbox_ctext{
        width: 100%;
        height: 0.5rem;
        line-height: 0.5rem;
        font-size: 0.37rem;
        margin-top: 2px;
        position: relative;
    }
    .sliderbox_ctext_view{
        width: auto;
        height: 0.5rem;
        position: absolute;
        left: -0.22rem;
        top: 0;
    }
    .mobhome_tview .sliderBox{
        width: 100%;
    }
    .mobhome_tview .loan-content-box{
        width: 100%;
        height: auto;
    }
    .mobhome_tview .moneybox{
        height: 1.138889rem;
        font-size: 1.0rem;
        padding-bottom: 0.527778rem
    }
    .mobhome_tview .moneybox span {
        font-size: 1.2rem;
    }
    .mobhome_tview .sliderBox{
        margin: 0.35rem auto 0 auto;
    }
    .mobhome_tview .el-slider__bar{
        height: 0.138889rem !important;
        border-radius: 0.069444rem !important;
    }
    .mobhome_tview .el-slider__runway{
        height: 0.138889rem !important;
        border-radius: 0.069444rem !important;
    }
    .mobhome_tview .el-slider__button-wrapper{
        width: 0.972222rem !important;
        height: 0.972222rem !important;
        top: -0.388889rem !important;
    }
    .mobhome_tview .sliderbox_wrap{
        height: 1.694444rem;
    }
    .mobhome_tview .eshoy_slider_btns{
        width: 7.722222rem;
        height: 1.111111rem;
        margin-top: 0.42rem;
        margin-bottom: 0.277778rem;
    }
    .mobhome_tview .eshoy_slider_btn_view{
        width: 7.722222rem;
        height: 1.111111rem;
    }

    .moneybox {
        font-size: 0.833333rem;
        font-weight: 600;
        color: #333333;
        text-align: center;
        text-align: center;
        padding-bottom: 74px;
    }

    .moneybox span {
        font-size: 1.0rem;
    }

    .sliderBox {
        width: 546px;
        height: auto;
        background: #E4EFEB;
        border-radius: 5px;
        margin: 24px auto 0 auto;
        position: relative;
    }

    .range {
        display: none;
        justify-content: space-between;
        margin-top: 35px;
    }

    .range p {
        font-size: 16px;
        color: #666;
        font-weight: 500;
    }

    .range p span {
        font-size: 18px;
    }
    .sliderbox_wrap{
        width: 10.583333rem;
        height: 1.194444rem;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
    }
    .sliderbox_left{
        width: 1.222222rem;
        height: 1.194444rem;
    }

    .sliderbox_right{
        width: 1.222222rem;
        height: 1.194444rem;
    }
    .sliderbox_cimg{
        width: 1.222222rem;
        height: 0.694444rem;
    }
    .sliderbox_ctext{
        width: 100%;
        height: 36px;
        font-size: 18px;
        font-weight: 500;
        color: #8C8480;
        line-height: 36px;
        text-align: center;
    }
    .sliderbox_ctext span{
        padding-left: 6px;
    }
    .eshoy_slider_btns{
        width: 378px;
        height: 72px;
        margin: 80px auto 0 auto;
        cursor: pointer;
        position: relative;
    }
    .eshoy_slider_btn_view{
        width: 378px;
        height: 72px;
    }
    .eshoy_slider_btns img{
        display: block;
        width: 100%;
    }
    .kychome_slider_title{
        width: 100%;
        height: 1.083333rem;
        font-size: 0.444444rem;
        font-weight: bold;
        color: #333333;
        line-height: 1.083333rem;
        text-align: center;
    }
    .kychome_slider_title_one{
        width: 100%;
        height: 0.805556rem;
        font-size: 0.444444rem;
        font-weight: 400;
        color: #666666;
        line-height: 0.527778rem;
        text-align: center;
    }
    .kychome_slider_title_two{
        width: 100%;
        height: 1.0rem;
        font-size: 0.5rem;
        font-weight: 500;
        color: #333333;
        line-height: 0.583333rem;
        text-align: center;
        margin-top: 20px;
    }
    .menus_wrap{
        width: 100%;
        height: 100vh;
        position: relative;
    }
    .menus_head{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0.833333rem 0 1.055556rem 0.694444rem;
    }
    .menus_head img{
        display: block;
        width: 1.388889rem;
        height: 1.388889rem;
    }
    .menus_footer{
        width: 100%;
        height: 2.2rem;
        background: #F6F6F6;
        border-radius: 0px 0px 0px 0.555556rem;
        position: absolute;
        left: 0;
        bottom: 0;
        box-sizing: border-box;
        padding: 0.555556rem 0 0 0.694444rem;
        display: flex;
        justify-content: flex-start;
    }
    .menus_ficon{
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .menus_ficon img{
        display: block;
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .menus_ftext{
        width: 1.388889rem;
        height: 0.555556rem;
        margin-left: 0.361111rem;
        font-size: 0.388889rem;
        font-weight: 500;
        color: #666666;
        line-height: 0.555556rem;
    }
    .menus_list{
        width: 100%;
        height: auto;
    }
    .menus_items{
        width: 100%;
        height: 1.305556rem;
    }
    .menus_item{
        width: 100%;
        height: 1.111111rem;
        box-sizing: border-box;
        padding-left: 0.694444rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .menus_iicon{
        width: 0.916667rem;
        height: 0.555556rem;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        padding-right: 0.361111rem;
    }
    .menus_iicon01{
        display: block;
        width: 0.555556rem;
        height: 0.5rem;
    }
    .menus_iicon02{
        display: block;
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .menus_iicon03{
        display: block;
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .menus_iicon04{
        display: block;
        width: 0.5rem;
        height: 0.555556rem;
    }
    .menus_itext{
        width: auto;
        height: 0.555556rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #333333;
        line-height: 0.555556rem;
    }
    .menus_cview{
        width: 100%;
        height: 1.861111rem;
    }
    .menus_items_active .menus_item{
        background: #19A95C;
    }
    .menus_items_active .menus_itext{
        color: #FFFFFF;
    }

    #firstloan_head .audithome_cont{
        width: 100%;
        height: auto;
        position: relative;
    }
    #firstloan .audithome_cont_height{
        height: 6.2rem;
    }
    #firstloan_head .audithome_cview{
        width: 100%;
        height: 14.555556rem;
        position: absolute;
        left: 0;
        top: -7.694444rem;
    }
    #firstloan_head .auditpass_wrap{
        width: 100%;
        height: auto;
        position: relative;
    }
    #firstloan_head .auditpass_bgimg{
        display: block;
        width: 100%;
    }
    #firstloan_head .audithome_cont .auditpass_view{
        width: 100%;
        height: auto;
        position: absolute;
        left: 0;
        top: 0;
        box-sizing: border-box;
        padding-top: 4.222222rem;
    }
    #firstloan_head .auditpass_title{
        width: 100%;
        height: 0.972222rem;
        font-size: 0.583333rem;
        font-weight: bold;
        color: #333333;
        line-height: 0.583333rem;
        text-align: center;
    }
    #firstloan_head .auditpass_desc{
        width: 92.22%;
        height: auto;
        margin: 0 auto;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #666666;
        line-height: 0.472222rem;
        text-align: center;
    }
    #firstloan_head .auditpass_solid_view{
        width: 100%;
        height: 0.388889rem;
        margin-top: 4.25rem;
        box-sizing: border-box;
        padding: 0 0.444444rem;
        display: flex;
        justify-content: space-between;
    }
    #firstloan_head .auditpass_solid_middle{
        width: auto;
        height: 0.388889rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #19A95C;
        line-height: 0.388889rem;
    }
    #firstloan_head .auditpass_solid_left{
        width: 2.916667rem;
        height: 0.388889rem;
        display: flex;
        align-items: center;
    }
    #firstloan_head .auditpass_solid_left img{
        display: block;
        width: 100%;
        height: 1px;
    }
    #firstloan_head .auditpass_solid_right{
        width: 2.916667rem;
        height: 0.388889rem;
        display: flex;
        align-items: center;
    }
    #firstloan_head .auditpass_solid_right img{
        display: block;
        width: 100%;
        height: 1px;
    }
    #firstloan_head .auditpass_times{
        width: 100%;
        height: 0.833333rem;
        display: flex;
        align-items: center;
    }
    #firstloan_head .zpan_hthr_times{
        width: auto;
        height: 0.694444rem;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
    }
    #firstloan_head .zpan_hthr_ditmes_day {
        width: auto;
        height: 0.694444rem;
        line-height: 0.694444rem;
        font-size: 12px;
        color: #333333;
        font-weight: bold;
        padding: 0 2px;
    }
    #firstloan_head .zpan_hthr_titmes{
        width: 0.694444rem;
        height: 0.694444rem;
        background: #ffffff;
        border-radius: 0.083333rem;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        border: 1px solid #BCDCCA;
    }
    #firstloan_head .zpan_hthr_titmes span{
        width: 100%;
        font-size: 0.388889rem;
        font-weight: 600;
        color: #19A95C;
        text-align: center;
    }
    #firstloan_head .zpan_hthr_ditmes{
        width: 0.388889rem;
        height: 0.583333rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    #firstloan_head .auditpass_btns{
        width: 92.22%;
        height: 1.222222rem;
        margin: 0 auto;
    }
    #firstloan_head{
        padding-bottom: 30px;
    }
    .audithome_tps_text{
        width: 11rem;
        color: #333333;
        font-size: 12px;
        line-height: 0.833333rem;
        text-align: center;
    }
    .firstloan_amount{
        width: 100%;
        height: auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
        padding: 20px 0.416667rem 0 0.416667rem;
    }
    .firstloan_amount_left{
        width: 60%;
        height: auto;
    }
    .firstloan_amount_right{
        width: 40%;
        height: auto;
    }
    .firstloan_amount_title{
        width: 100%;
        height: auto;
        font-size: 16px;
        color: #333333;
    }
    .firstloan_amount_days{
        font-size: 1.0rem;
    }
    .firstloan_amount_days span{
        font-size: 1.2rem;
    }
    .confirmloan_cmview {
        width: 100%;
        height: auto;
    }
    .confirmloan_cmview .itoken_check_vitleft {
        color: #808080;
    }
    .confirmloan_cmitems {
        width: 100%;
        height: 1.277778rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .confirmloan_cmileft {
        width: auto;
        height: auto;
        font-size: 14px;
        font-weight: 400;
        color: #69706e;
    }
    .confirmloan_cmiright {
        width: auto;
        height: auto;
        font-size: 14px;
        font-weight: 400;
        color: #303332;
    }
    .confirmloan_cmview .itoken_check_vitems {
        padding-top: 0.444444rem;
        padding-bottom: 0.444444rem;
    }
    .itoken_checkvi_scale-1px {
        position: relative;
        border: none;
    }
    .itoken_checkvi_scale-1px:after {
        content: '';
        position: absolute;
        bottom: 0;
        background: #dfdcdc;
        width: 100%;
        height: 1px;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }
    ..itoken_check_vitem {
        width: 100%;
        height: auto;
    }
    .itoken_check_vitop {
        width: 100%;
        height: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .itoken_check_vitleft {
        width: auto;
        height: 14px;
        font-size: 14px;
        font-weight: 400;
        color: #1a1a1a;
    }
    .itoken_check_vitright {
        width: auto;
        height: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 2px;
    }
    .itoken_check_vitrnums {
        width: auto;
        height: 14px;
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 500;
        color: #1a1a1a;
    }
    .itoken_check_vitrnums span {
        font-size: 14px;
        font-weight: 500;
        color: #1a1a1a;
        padding-right: 4px;
    }
    .itoken_check_vitrarrow {
        width: 14px;
        height: 14px;
        margin-left: 4px;
    }
    .itoken_check_vitrarrow img {
        display: block;
        width: 100%;
    }
    .itoken_check_vitleft_coupon {
        width: auto;
        height: 14px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .itoken_check_vitleft_coupon span {
        font-size: 14px;
        font-weight: 400;
        color: #69706e;
    }
    .confirmloan_cmcontrato_wrap {
        width: 100%;
        height: auto;
        padding: 11px 0 49px 0;
    }
    .confirmloan_cmcontrato_cont {
        width: 100%;
        height: 24px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .confirmloan_cmcontrato_cleft {
        width: auto;
        height: 24px;
        display: flex;
        align-items: center;
    }
    .confirmloan_cmcontrato_cleft img {
        display: block;
        width: 24px;
        height: 24px;
    }
    .itoken_check_vitems_details {
        width: 100%;
        height: auto;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-bottom: 1.333333rempx;
    }
    .itoken_check_vitems_detail {
        width: 100%;
        height: auto;
        background: #f4f5f4;
        border-radius: 8px;
        box-sizing: border-box;
        padding: 7px 14px;
    }
    .confirmloan_msgitems {
        width: 100%;
        height: 0.75rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .confirmloan_msgileft {
        width: auto;
        height: 13px;
        font-size: 13px;
        font-weight: 400;
        color: #69706e;
        line-height: 13px;
    }
    .confirmloan_msgiright {
        width: auto;
        height: 13px;
        font-size: 13px;
        font-weight: 500;
        color: #69706e;
        line-height: 13px;
    }
    .confirmloan_msgiright span {
        padding-left: 10px;
    }
    .confirmloan_msgiright .delete__line{
        text-decoration: line-through;
    }
    .firstloan_loantitle{
        width: 100%;
        height: auto;
        font-size: 18px;
        color: #333333;
        font-weight: bold;
    }
    .confirmloan_cmview_repeat{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0 16px;
    }
</style>

<style>
    .verifycode_wrap{
        width: 100%;
        height: auto;
    }
    .verifycode_cont{
        width: 100%;
        height: auto;
        background: #FFFFFF;
        border-radius: 0.555556rem 0.555556rem 0px 0px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-top: 0.222222rem;
    }
    .verifycode_tilte{
        width: 1.25rem;
        height: 0.083333rem;
        background: #CFCFCF;
        border-radius: 0.083333rem;
        margin: 0 auto;
    }
    .verifycode_top{
        width: 100%;
        height: 2.583333rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 0.555556rem 0.444444rem 0 0.444444rem;
        display: flex;
        justify-content: space-between;
    }
    .verifycode_tleft{
        width: auto;
        height: 0.611111rem;
        font-size: 0.527778rem;
        font-weight: bold;
        color: #1A1A1A;
        line-height: 44px;
        display: flex;
        align-items: center;
    }
    .verifycode_tleft span{
        float: left
    }
    .verifycode_tright{
        width: 0.666667rem;
        height: 0.666667rem;
    }
    .verifycode_tright img{
        display: block;
        width: 100%;
    }
    .verifycode_form{
        width: 91.11%;
        height: 5.972222rem;
        margin: 0 auto;
    }
    .verifycode_items_scale-1px{
        position: relative;
        border:none;
    }
    .verifycode_items_scale-1px:after{
        content: '';
        position: absolute;
        bottom: 0;
        background: #E7E7E7;
        width: 100%;
        height: 1px;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }
    .verifycode_items{
        width: 100%;
        height: 1.444444rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }
    .verifycode_item{
        width: 100%;
        height: 1.166667rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .verifycode_ioneleft{
        width: 1.055556rem;
        height: 1.166667rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #1A1A1A;
        line-height: 1.166667rem;
    }
    .verifycode_ioneright{
        width: 7.777778rem;
        height: 1.166667rem;
    }
    .verifycode_ioneright input{
        display: block;
        width: 100%;
        height: 1.12rem;
        outline: none;
        border: none;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #1A1A1A;
        background: #ffffff;
        padding: 0;
    }
    .verifycode_itemtwo{
        justify-content: space-between;
    }
    .verifycode_itwoleft{
        width: 4.0rem;
        height: 1.166667rem;
    }
    .verifycode_itwoleft input{
        display: block;
        width: 100%;
        height: 1.1rem;
        outline: none;
        border: none;
        font-size: 0.388889rem;
        font-weight: 500;
        color: #1A1A1A;
        background: #ffffff;
    }

    .verifycode_itworight #sendcode.active{
        background: #CFCFCF;
    }
    .verifycode_iwarn_scale-1px{
        position: relative;
        border:none;
    }
    .verifycode_iwarn_scale-1px:after{
        content: '';
        position: absolute;
        bottom: 0;
        background: #DB861F;
        width: 100%;
        height: 1px;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }
    .verifycode_fwran_view{
        width: 100%;
        height: auto;
        padding-top: 0.388889rem;
        font-size: 0.388889rem;
        font-family: Roboto-Regular, Roboto;
        font-weight: 500;
        color: #DB861F;
    }
    .verifycode_google_wrap{
        width: 100%;
        height: 2.388889rem;
    }
    .verifycode_google_cont{
        width: 7.305556rem;
        height: 1.944444rem;
        margin: 0 auto;
    }
    .verifycode_footer_btns{
        width: 100%;
        height: 1.666667rem;
    }
    .verifycode_footer_btn{
        width: 91.11%;
        height: 1.222222rem;
        margin: auto;
    }
    .verifycode_footer_xys{
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
        padding-bottom: 0.555556rem;
    }
    .verifycode_footer_xy{
        font-size: 14px;
        transform: scale(0.79);
        font-weight: 400;
        color: #00CA88;
    }
    .verifycode_footer_xy span{
        text-decoration: underline;
    }

    .verifycode_coupons_top{
        width: 100%;
        height: 1.6rem;
    }
    .coupons_form{
        width: 100%;
        min-height: 2.611111rem;
        max-height: 10.444444rem;
        overflow-x: hidden;
        overflow-y: scroll;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 0 0.444444rem 0.888889rem 0.444444rem;
    }
    .coupons_list{
        width: 100%;
        height: auto;
    }
    .coupons_items{
        width: 100%;
        padding-bottom: 0.444444rem;
    }
    .coupons_items_end{
        padding-bottom: 0;
    }
    .coupons_items .coupons_active{
        border: 1px solid #00CA88;
    }
    .coupons_item{
        width: 100%;
        height: 2.166667rem;
        background: #F6F6F6;
        border: 1px solid #F6F6F6;
        border-radius: 0.333333rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .coupons_ileft{
        width: 89.93%;
        height: 2.166667rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 0.555556rem 0 0 0.444444rem;
    }
    .coupons_ilname{
        width: 100%;
        height: 0.666667rem;
        font-size: 0.5rem;
        font-weight: 500;
        color: #1A1A1A;
    }
    .coupons_ildesc{
        width: 100%;
        height: auto;
        font-size: 0.388889rem;
        font-weight: 500;
        color: #808080;
    }
    .coupons_iright{
        width: 10.07%;
        height: 2.166667rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .coupons_irview{
        width: 0.472222rem;
        height: 0.472222rem;
    }
    .coupons_irview img{
        display: block;
        width: 0.472222rem;
        height: 0.472222rem;
    }
    .coupons_items .van-cell{
        padding: 0 !important;
        background-color: #F6F6F6;
        border-radius: 0.333333rem;
    }
    .coupons_list .van-hairline--top-bottom::after, .coupons_list .van-hairline-unset--top-bottom::after{
        border-width: 0 !important;
    }
</style>

